module.exports = __webpack_public_path__ + "static/img/heroimage_transaction_small.8039d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_transaction_small.png
// module id = 244
// module chunks = 1